// Theme: polaroid
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'polaroid',
  name: 'POLAROID',
  tagline: 'POLAROID',
  description: 'Laranja analogico quente com gradiente leve de BP free.',
  category: 'retro-memory',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#4B1A0E', '#6B2A1A', '#FF6A3D', '#FFF5F2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-sans theme-polaroid'
  },
  colorVars: {
    '--accent': '#FF6A3D',
    '--accent-foreground': '#4B1A0E',
    '--background': '#4B1A0E',
    '--border': '#C45A35',
    '--card': '#6B2A1A',
    '--card-border-active': 'rgba(255, 106, 61, 0.40)',
    '--card-completed': '#5B2416',
    '--card-foreground': '#FFF5F2',
    '--card-glow': 'rgba(255, 106, 61, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#FFF5F2',
    '--hold-fill': '#FF6A3D',
    '--input': '#C45A35',
    '--modal-bg': '#4B1A0E',
    '--modal-border': '#C45A35',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C45A35',
    '--muted-foreground': '#FFF5F2',
    '--nav-active': '#FF6A3D',
    '--nav-bg': '#6B2A1A',
    '--popover': '#6B2A1A',
    '--popover-foreground': '#FFF5F2',
    '--primary': '#FF6A3D',
    '--primary-foreground': '#4B1A0E',
    '--ring': '#FF6A3D',
    '--secondary': '#C45A35',
    '--secondary-foreground': '#FFF5F2',
    '--streak': '#FF6A3D',
    '--success': '#22c55e',
    '--success-foreground': '#4B1A0E',
    '--xp': '#FF6A3D',
    '--xp-bg': '#6B2A1A'
  },
  resolvedVars: {
    '--accent': '#FF6A3D',
    '--accent-foreground': '#4B1A0E',
    '--accent-foreground-hsl': '12 69% 17%',
    '--accent-foreground-oklch': 'from #4B1A0E l c h',
    '--accent-hsl': '14 100% 62%',
    '--accent-oklch': 'from #FF6A3D l c h',
    '--background': '#4B1A0E',
    '--background-hsl': '12 69% 17%',
    '--background-oklch': 'from #4B1A0E l c h',
    '--border': '#C45A35',
    '--border-hsl': '16 57% 49%',
    '--border-oklch': 'from #C45A35 l c h',
    '--border-w': '1px',
    '--card': '#6B2A1A',
    '--card-border-active': 'rgba(255, 106, 61, 0.40)',
    '--card-completed': '#5B2416',
    '--card-completed-hsl': '12 61% 22%',
    '--card-completed-oklch': 'from #5B2416 l c h',
    '--card-foreground': '#FFF5F2',
    '--card-foreground-hsl': '14 100% 97%',
    '--card-foreground-oklch': 'from #FFF5F2 l c h',
    '--card-glow': 'rgba(255, 106, 61, 0.06)',
    '--card-hsl': '12 61% 26%',
    '--card-oklch': 'from #6B2A1A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF5F2',
    '--foreground-hsl': '14 100% 97%',
    '--foreground-oklch': 'from #FFF5F2 l c h',
    '--hold-fill': '#FF6A3D',
    '--hold-fill-hsl': '14 100% 62%',
    '--hold-fill-oklch': 'from #FF6A3D l c h',
    '--input': '#C45A35',
    '--input-hsl': '16 57% 49%',
    '--input-oklch': 'from #C45A35 l c h',
    '--modal-bg': '#4B1A0E',
    '--modal-bg-hsl': '12 69% 17%',
    '--modal-bg-oklch': 'from #4B1A0E l c h',
    '--modal-border': '#C45A35',
    '--modal-border-hsl': '16 57% 49%',
    '--modal-border-oklch': 'from #C45A35 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C45A35',
    '--muted-foreground': '#FFF5F2',
    '--muted-foreground-hsl': '14 100% 97%',
    '--muted-foreground-oklch': 'from #FFF5F2 l c h',
    '--muted-hsl': '16 57% 49%',
    '--muted-oklch': 'from #C45A35 l c h',
    '--nav-active': '#FF6A3D',
    '--nav-active-hsl': '14 100% 62%',
    '--nav-active-oklch': 'from #FF6A3D l c h',
    '--nav-bg': '#6B2A1A',
    '--nav-bg-hsl': '12 61% 26%',
    '--nav-bg-oklch': 'from #6B2A1A l c h',
    '--popover': '#6B2A1A',
    '--popover-foreground': '#FFF5F2',
    '--popover-foreground-hsl': '14 100% 97%',
    '--popover-foreground-oklch': 'from #FFF5F2 l c h',
    '--popover-hsl': '12 61% 26%',
    '--popover-oklch': 'from #6B2A1A l c h',
    '--primary': '#FF6A3D',
    '--primary-foreground': '#4B1A0E',
    '--primary-foreground-hsl': '12 69% 17%',
    '--primary-foreground-oklch': 'from #4B1A0E l c h',
    '--primary-hsl': '14 100% 62%',
    '--primary-oklch': 'from #FF6A3D l c h',
    '--radius': '10px',
    '--ring': '#FF6A3D',
    '--ring-hsl': '14 100% 62%',
    '--ring-oklch': 'from #FF6A3D l c h',
    '--secondary': '#C45A35',
    '--secondary-foreground': '#FFF5F2',
    '--secondary-foreground-hsl': '14 100% 97%',
    '--secondary-foreground-oklch': 'from #FFF5F2 l c h',
    '--secondary-hsl': '16 57% 49%',
    '--secondary-oklch': 'from #C45A35 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FF6A3D',
    '--streak-hsl': '14 100% 62%',
    '--streak-oklch': 'from #FF6A3D l c h',
    '--success': '#22c55e',
    '--success-foreground': '#4B1A0E',
    '--success-foreground-hsl': '12 69% 17%',
    '--success-foreground-oklch': 'from #4B1A0E l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(14 100% 62% / 0.15)',
    '--xp': '#FF6A3D',
    '--xp-bg': '#6B2A1A',
    '--xp-bg-hsl': '12 61% 26%',
    '--xp-bg-oklch': 'from #6B2A1A l c h',
    '--xp-hsl': '14 100% 62%',
    '--xp-oklch': 'from #FF6A3D l c h'
  }
}
